// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");

function UserKpiListHeader(props) {
  return JsxRuntime.jsx("thead", {
              children: JsxRuntime.jsxs("tr", {
                    children: [
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    "Email",
                                    JsxRuntime.jsx("img", {
                                          className: "ml-4-px",
                                          src: Image$ReactHooksTemplate.heading
                                        })
                                  ],
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    "Field",
                                    JsxRuntime.jsx("img", {
                                          className: "ml-4-px",
                                          src: Image$ReactHooksTemplate.heading
                                        })
                                  ],
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    "Value",
                                    JsxRuntime.jsx("img", {
                                          className: "ml-4-px",
                                          src: Image$ReactHooksTemplate.heading
                                        })
                                  ],
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    "KPI",
                                    JsxRuntime.jsx("img", {
                                          className: "ml-4-px",
                                          src: Image$ReactHooksTemplate.heading
                                        })
                                  ],
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsx("div", {
                                  children: "",
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          })
                    ]
                  }),
              className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
            });
}

var make = UserKpiListHeader;

exports.make = make;
/* react/jsx-runtime Not a pure module */
